import { ShieldCheck, Eraser, CloudOff, Settings, Cpu, ListChecks, ScanBarcode, LockOpen } from 'lucide-react';

const ITEMS = [
  { id: 'warranty', Icon: ShieldCheck, tag: '12', label: 'Garanție 12 luni', c: 'text-sky-600', bg: 'bg-sky-100' },
  { id: 'wiped', Icon: Eraser, label: 'Date șterse, gata de folosire', c: 'text-orange-500', bg: 'bg-orange-100' },
  { id: 'icloud', Icon: CloudOff, label: 'Fără iCloud', c: 'text-emerald-600', bg: 'bg-emerald-100' },
  { id: 'mdm', Icon: Settings, tag: 'MDM', label: 'Fără administrare MDM', c: 'text-pink-600', bg: 'bg-pink-100' },
  { id: 'hardware', Icon: Cpu, label: 'Hardware testat', c: 'text-purple-600', bg: 'bg-purple-100' },
  { id: 'software', Icon: ListChecks, tag: '60+', label: 'Software testat în 60 de puncte', c: 'text-indigo-500', bg: 'bg-indigo-100' },
  { id: 'esn', Icon: ScanBarcode, label: 'IMEI curat', c: 'text-red-500', bg: 'bg-red-100' },
  { id: 'frp', Icon: LockOpen, tag: 'FRP', label: 'Fără blocare la resetare', c: 'text-teal-600', bg: 'bg-teal-100' },
];

export const PreOwnedGuarantees = () => (
  <div className="my-6 grid grid-cols-4 gap-x-2 gap-y-4 rounded-2xl border border-gray-100 bg-white p-4 sm:grid-cols-8"
    data-testid="preowned-guarantees">
    {ITEMS.map(({ id, Icon, tag, label, c, bg }) => (
      <div key={id} className="flex flex-col items-center text-center" data-testid={`preowned-guarantee-${id}`}>
        <div className={`relative flex h-11 w-11 items-center justify-center rounded-xl ${bg}`}>
          <Icon className={`h-5 w-5 ${c}`} strokeWidth={1.8} />
          {tag && (
            <span className={`absolute -right-2 -top-2 rounded-md bg-white px-1 text-[9px] font-bold leading-4 shadow-sm ${c}`}>
              {tag}
            </span>
          )}
        </div>
        <p className={`mt-1.5 text-[11px] font-medium leading-tight ${c}`}>{label}</p>
      </div>
    ))}
  </div>
);
